import { css } from '@emotion/core'
import { measures } from 'styles/variables'

const { unit } = measures

export const control = css`
  &:disabled {
    background-color: transparent;
  }
`

export const buttonContainer = css`
  display: flex;
  justify-content: center;
  width: ${unit * 38}px;
`
